import { render, staticRenderFns } from "./PalletsStats.vue?vue&type=template&id=1763afe1&scoped=true"
import script from "./PalletsStats.vue?vue&type=script&lang=js"
export * from "./PalletsStats.vue?vue&type=script&lang=js"
import style0 from "./PalletsStats.vue?vue&type=style&index=0&id=1763afe1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1763afe1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
